import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { AccountKey } from 'owa-client-types';

const resetMailRibbonConfigurationMutator: (accountKey: AccountKey) => void = mutatorAction(
    'resetMailRibbonConfiguration',
    (accountKey: AccountKey): void => {
        const ribbonStore = getStore().entries.get(accountKey);
        if (ribbonStore) {
            ribbonStore.hasLoaded = false;
        }
    }
);

export default resetMailRibbonConfigurationMutator;
